import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { Fade } from "@progress/kendo-react-animation";
import { Button } from "@progress/kendo-react-buttons";
import { SvgIcon } from "@progress/kendo-react-common";
import { FlatColorPicker, TextBox } from "@progress/kendo-react-inputs";
import { useLocalization } from "@progress/kendo-react-intl";
import { Avatar } from "@progress/kendo-react-layout";
import { NotificationGroup, Notification } from "@progress/kendo-react-notification";
import { copyIcon, plusIcon, saveIcon, trashIcon } from "@progress/kendo-svg-icons";
import axios from "axios";
import { useEffect, useState } from "react";
import { AccessToken } from "../../../config/AccessToken";
import { loadingPanel } from "../../LoadingPanel";

export const ConfigZones = () => {

    const localizationService = useLocalization();
    let languageId = localStorage.getItem('languageId');
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [instance, accessTokenRequest] = AccessToken();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<any>(false);
    const [errorMessage, setErrorMessage] = useState<any>('');



    const [valueColor, setValueColor] = useState<any>('#ffffff');
    const [jobsList, setJobsList] = useState<any>([]);
    const [toggleColorPicker, setToggleColorPicker] = useState<boolean>(false);

    const [messageDeletedJob, setMessageDeletedJob] = useState<boolean>(false);
    const [messageSavedJob, setMessageSavedJob] = useState<boolean>(false);
    const [messageClonedJob, setMessageClonedJob] = useState<boolean>(false);
    const [messageUpdatedJob, setMessageUpdatedJob] = useState<boolean>(false);

    const [jobName, setJobName] = useState<any>('');
    const [updateJob, setUpdateJob] = useState<boolean>(false);

    const [jobInfo, setJobInfo] = useState<any>([
        {
            'id': '',
            'name': '',
            'color': '',
            'startDate': new Date()
        }
    ]);

   
    

    useEffect(() => {
        getJobList(true);
    }, []);

    const getJobList = async (flag: boolean) => {

        setLoading(true);
        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/job/list?enabled=${flag}`, { headers })
                .then((res) => {
                    const data = res?.data?.data

                    let jobList: any = []
                    data.forEach((job: any) => {
                        if(job.id != -1)
                            jobList.push(job)
                    });


                    setJobsList(jobList);
                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                });
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    };

    const rgba2hex = (rgba: any) => {
        return "#" + rgba.replace(/^rgba?\(|\s+|\)$/g, '') // Get's rgba / rgb string values
            .split(',') // splits them at ","
            .filter((string: any, index: any) => index !== 3)
            .map((string: any) => parseFloat(string)) // Converts them to numbers
            .map((number: any, index: any) => index === 3 ? Math.round(number * 255) : number) // Converts alpha to 255 number
            .map((number: any) => number.toString(16)) // Converts numbers to hex
            .map((string: any) => string.length === 1 ? "0" + string : string) // Adds 0 when length of one number is 1
            .join("")
    }

    const handleChangeColor = (event: any) => {
        let color:any = rgba2hex(event.value);
        setValueColor(color);
    };

    const showColorPicker = () => {
        setToggleColorPicker(!toggleColorPicker);
    }

    const handleChangeJobName = (event: any) => {
        let currentName:any = event.target.value
        setJobName(currentName)

        if(currentName == ''){
            setJobName([]);
        }else{
            let newGroup: any = [];
            newGroup.push({ 'id': jobInfo[0]?.id, 'name': currentName, 'description': jobInfo[0]?.description, 'color': jobInfo[0]?.color, 'job': jobInfo[0]?.job, 'type': jobInfo[0]?.type })
            setJobInfo(newGroup);
        }
    }

    const getSelectedJob = (job: any) => {
        setJobInfo([{ 'id': job.id, 'name': job.name, 'color': job.color, 'startDate': new Date().toJSON() }]);
        setJobName(job.name);
        setValueColor(job.color);
        setUpdateJob(true)
    }

    const updateSelectedJob = async (jobId: any, jobName: any, jobColor: any) => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            
            try {
                await axios.put(`${SERVER_URL}/job/${jobId}/?name=${jobName}&color=${encodeURIComponent(jobColor)}`, null, { headers })
                setJobName('');
                handleChangeJobName({ target: { value: '' } })
                handleChangeColor({ value: '#ffffff' })
                setValueColor('#ffffff')
                setUpdateJob(false)
                getJobList(true);

                setLoading(false)
                setMessageUpdatedJob(true);
                if (!messageUpdatedJob) {
                    setTimeout(() => {
                        setMessageUpdatedJob(false);
                    }, 3000);
                }

            } catch (error: any) {
                setError(error);
                setErrorMessage(error?.response?.data?.errorMessage)
                setLoading(false)
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
        
        
    }

    const formatDateFromIsoToString = (isoString:any) => {
        const date = new Date(isoString);
      
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
      
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }

    const saveNewJob = async (currJobName: any, currValueColor: any) => {

        setLoading(true);

        const startDate:any = formatDateFromIsoToString(new Date().toJSON())

        let currJob: any = [{ 'id': currJobName[0].id, 'name': currJobName[0].name, 'color': currValueColor, 'startDate': startDate }];

        if (jobsList.length > 0 && currJobName[0].name != '') {
            if (jobsList.some((e: any) => e.name === currJobName[0].name) || currJobName.length == 0) {
            } else {
                setJobsList([...jobsList, currJob[0]]);
            }

        } else {
            setJobsList([...jobsList, currJobName]);
        }

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const params = {
                name: currJob[0].name,
                color: currJob[0].color,
                startDate: currJob[0].startDate
            };
            try {
                await axios.post(`${SERVER_URL}/job`, params, { headers })
                handleChangeJobName({ target: { value: '' } })
                handleChangeColor({ value: '' })
                setLoading(false)

                getJobList(true);
                
                setMessageSavedJob(true);
                if (!messageSavedJob) {
                    setTimeout(() => {
                        setMessageSavedJob(false);
                    }, 3000);
                }
            } catch (error: any) {
                setError(error);
                if (error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
                setLoading(false)
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }
    
    const cloneJob = async (jobInfo: any) => {

        setLoading(true);

        const startDate:any = formatDateFromIsoToString(new Date().toJSON())

        let currJob: any = [{ 'id': jobInfo.id, 'name': jobInfo.name, 'color': jobInfo.color, 'startDate': startDate }];

        if (jobsList.length > 0 && jobInfo.name != '') {
            if (jobsList.some((e: any) => e.name === jobInfo.name) || jobInfo.name.length == 0) {
            } else {
                setJobsList([...jobsList, currJob[0]]);
            }

        } else {
            setJobsList([...jobsList, jobInfo.name]);
        }

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const params = {
                name: currJob[0].name,
                color: currJob[0].color,
                startDate: currJob[0].startDate
            };
            try {
                await axios.post(`${SERVER_URL}/job`, params, { headers })
                handleChangeJobName({ target: { value: '' } })
                handleChangeColor({ value: '#ffffff' })
                setValueColor('#ffffff')
                setLoading(false)

                getJobList(true);
                
                setMessageClonedJob(true);
                if (!messageClonedJob) {
                    setTimeout(() => {
                        setMessageClonedJob(false);
                    }, 3000);
                }
            } catch (error: any) {
                setError(error);
                if (error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
                setLoading(false)
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }

    const removeNewJob = async (jobId: any, index: any) => {

        setLoading(true);
        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            try {
                await axios.delete(`${SERVER_URL}/job/${jobId}`, { headers }),
                    setJobsList((oldValues: any) => {
                        return oldValues.filter((_: any, i: any) => i !== index)
                    })
                handleChangeJobName({ target: { value: '' } })
                handleChangeColor({ value: '' })
                setLoading(false)
                setMessageDeletedJob(true)
            } catch (error: any) {
                setError(true);
                if (!error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
                setLoading(false)
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }

        if (!messageDeletedJob || !error) {
            setTimeout(() => {
                setMessageDeletedJob(false);
                setError(false);
            }, 3000);
        }
    }

    const refreshJob = () => {
        handleChangeJobName({ target: { value: '' } })
        handleChangeColor({ value: '#ffffff' })
        setValueColor('#ffffff')
        setUpdateJob(false);
    }

    return (
        <div className="flex-parent-element" style={{ overflowX: 'hidden' }}>
            {loading && loadingPanel}
            <NotificationGroup
                    style={{
                        right: 0,
                        bottom: 0,
                        position: "absolute",
                        alignItems: "flex-start",
                        flexWrap: "wrap-reverse",
                    }}
                >
                    <Fade enter={true} exit={true}>
                        {messageDeletedJob && (
                            <Notification
                                type={{ style: "success", icon: true }}
                                onClose={() => setMessageDeletedJob(false)}
                            >
                                <span>{localizationService.toLanguageString('configuration.registry.job_deleted', 'NOT FOUND')}</span>
                            </Notification>
                        )}
                        {messageSavedJob && (
                            <Notification
                                type={{ style: "success", icon: true }}
                                onClose={() => setMessageSavedJob(false)}
                            >
                                <span>{localizationService.toLanguageString('configuration.registry.job_saved', 'NOT FOUND')}</span>
                            </Notification>
                        )}
                        {messageClonedJob && (
                            <Notification
                                type={{ style: "success", icon: true }}
                                onClose={() => setMessageClonedJob(false)}
                            >
                                <span>{localizationService.toLanguageString('configuration.registry.job_cloned', 'NOT FOUND')}</span>
                            </Notification>
                        )}
                        {messageUpdatedJob && (
                            <Notification
                                type={{ style: "success", icon: true }}
                                onClose={() => setMessageUpdatedJob(false)}
                            >
                                <span>{localizationService.toLanguageString('configuration.registry.job_updated', 'NOT FOUND')}</span>
                            </Notification>
                        )}
                        {error && (
                            <Notification
                                type={{ style: "error", icon: true }}
                                //closable={true}
                                onClose={() => setMessageSavedJob(false)}
                            >
                                {
                                    errorMessage
                                    ?
                                    <span>{errorMessage}</span>
                                    :
                                    <span>{localizationService.toLanguageString('configuration.registry.job_with_device_error', 'NOT FOUND')}</span>
                                }
                            </Notification>
                        )}
                    </Fade>
            </NotificationGroup>

            <div         
                style={{ 
                    //display: 'inline-table', 
                    padding: '20px', 
                    backgroundColor: '#f7f7f7',
                    overflowY: 'auto',     
                }}
            >
                <div style={{ textAlign:'center', marginBottom:'20px' }}>

                    <p style={{ display:'inline-flex', textAlign: 'center', fontSize: '20px', color: '#1A8893', }}>{localizationService.toLanguageString('configuration.registry.jobs', 'NOT_FOUND')} ({jobsList.length})</p>
                    <Button
                        title={localizationService.toLanguageString('configuration.registry.job_new', 'NOT FOUND')}
                        themeColor={"primary"}
                        className="plusParam"
                        style={{
                            marginRight: '10px',
                            marginTop: '0px',
                        }}
                        onClick={refreshJob}
                    >
                        <Avatar
                            className="plusParam"
                        >
                            <SvgIcon
                                icon={plusIcon}
                                style={{ margin: '8px' }}
                            />
                        </Avatar>
                    </Button>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {jobsList?.map((job: any, index: any) => {
                        return (
                            job.id != -1 &&
                            <div key={index}>

                                <div
                                    className="trash-icon"
                                    title={localizationService.toLanguageString('configuration.registry.job_delete', 'NOT_FOUND')} 
                                    style={{
                                        float: 'left',
                                        cursor: 'pointer',
                                        alignContent: 'center',
                                        marginRight: '10px'
                                    }}
                                    onClick={() => {
                                        setUpdateJob(false)
                                        removeNewJob(job.id, index)
                                    }}
                                >
                                    <Avatar 
                                        className="trash-icon"
                                    >
                                        <SvgIcon 
                                            icon={trashIcon} 
                                            style={{ verticalAlign: 'baseline', margin: '10px' }} 
                                        />
                                    </Avatar>
                                </div>

                                <div
                                    className="trash-icon"
                                    style={{
                                        float: 'left',
                                        cursor: 'pointer',
                                        alignContent: 'center',
                                        marginRight: '10px'
                                    }}
                                    onClick={() => {
                                        setUpdateJob(false)
                                        cloneJob(job)
                                    }}                                     
                                    title={localizationService.toLanguageString('configuration.registry.job_clone', 'NOT FOUND')}
                                >
                                    <Avatar 
                                        className="trash-icon"
                                    >
                                        <SvgIcon 
                                            icon={copyIcon} 
                                            style={{ verticalAlign: 'baseline', margin: '10px' }} 
                                        />
                                    </Avatar>
                                </div> 


                                <div
                                    style={{ display: 'inline-flex' }}
                                    onClick={() => getSelectedJob(job)}
                                >
                                    <p 
                                        style={{ 
                                            border: `1px solid ${ (job?.color == '#ffffff' || job?.color == '#NaN') ? 'black' : job?.color}`, 
                                            borderRadius: '30px', 
                                            width: '18px', 
                                            height: '18px', 
                                            marginTop: '10px', 
                                            background: `${job?.color}` 
                                        }}
                                    ></p>
                                    <p
                                        className="card-block-registry-group"
                                        style={{
                                            cursor: 'pointer',
                                            marginLeft: '10px',
                                            padding: '7px'
                                        }}
                                    >
                                        {`${job?.id ?? ''}  : ${job?.name}`}
                                    </p>
                                </div>
                            </div>
                        )
                    })}
                </div>

            </div>

            
            <div 
                className="flex-right-child-element" 
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    background: 'white',
                    flexGrow: 1,
                    alignItems: 'center',
                    paddingLeft: '0px'
                }}
            >
                

                {/*colorpicker*/}
                {
                toggleColorPicker &&
                <div style={{display:'flex', flexDirection: 'column', width: '290px', marginTop:'20px'}}>
                    
                    <div
                        style={{
                            background: valueColor,
                        }}
                    >
                        <div className="kendoka" />
                    </div>
                    <div>
                        {/*<p>Choose color:</p>*/}
                        <FlatColorPicker
                            value={valueColor}
                            format="hex"
                            showButtons={false}
                            onChange={handleChangeColor}
                        />
                    </div>

                </div>
                }

            </div>
        </div>
    );


};